import { render } from "./IncomingPosts.vue?vue&type=template&id=2997c07e&scoped=true"
import script from "./IncomingPosts.vue?vue&type=script&lang=js"
export * from "./IncomingPosts.vue?vue&type=script&lang=js"

import "./IncomingPosts.vue?vue&type=style&index=0&id=2997c07e&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2997c07e"]])

export default __exports__